/* Support Page Script - Start */

(function () {
  // ---------- Tiny utils ----------
  const $$ = (sel, ctx = document) => Array.from((ctx || document).querySelectorAll(sel));
  const $  = (sel, ctx = document) => (ctx || document).querySelector(sel);
  const text = (el) => (el ? el.textContent.trim() : "");
  const escapeHtml = (s) => String(s).replace(/[&<>"']/g, (m) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[m]));
  const norm = (s) => (s || "").toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "");
  const debounce = (fn, ms=140) => { let t; return (...a)=>{ clearTimeout(t); t=setTimeout(()=>fn(...a),ms); }; };
  const ID_ALIASES = {}; // optional: map legacy ids -> canonical ids
  const findByData = (selector, attr, value, ctx = document) =>
    $$(selector, ctx).find((el) => el.getAttribute(attr) === value);

  const homeEl = $(".support-main-home") || $(".support-main");
  const allSections = () => $$(".support-main-question");

  function hide(el) { if (el) el.style.display = "none"; }
  function show(el) { if (el) el.style.display = ""; }

  function hideAllSections() {
    allSections().forEach((sec) => {
      hide(sec);
      sec.classList.remove("is-active", "answers-only");
      const qCol = $(".support-question-block", sec);
      if (qCol) show(qCol);
      $$(".main-answer", sec).forEach((a) => { hide(a); a.classList.remove("is-open"); });
      $$(".main-question", sec).forEach((q) => {
        show(q);
        q.classList.remove("is-open");
        q.setAttribute("aria-expanded", "false");
      });
    });
  }

  function resolveSectionId(rawId) { return ID_ALIASES[rawId] || rawId; }
  function getSectionById(rawId) {
    const id = resolveSectionId(rawId);
    return document.getElementById(id) || allSections().find((sec) => sec.id.includes(id));
  }

  function showSection(rawId) {
    const sec = getSectionById(rawId);
    if (!sec) return null;
    hide(homeEl);
    hideAllSections();
    show(sec);
    sec.classList.add("is-active");
    showBreadcrumb();
    return sec;
  }

  function showHome() {
    hideAllSections();
    show(homeEl);
    hideBreadcrumb();
  }

  function sectionLabelFrom(blockOrSection) {
    const blockText = $(".support-content-text", blockOrSection);
    if (blockText) return text(blockText).toUpperCase();
    const h2 = $(".main-question-title h2", blockOrSection);
    return (text(h2) || "SECTION").toUpperCase();
  }

  function articleCountLabel(count) {
    return `${count} article${count === 1 ? "" : "s"}`;
  }

  function parseDateValue(value) {
    const raw = String(value || "").trim();
    if (!raw) return null;

    const timestamp = Date.parse(raw);
    if (!Number.isNaN(timestamp)) return new Date(timestamp);

    const match = raw.match(/^(\d{1,2})[/-](\d{1,2})[/-](\d{2,4})$/);
    if (!match) return null;

    const month = Number(match[1]) - 1;
    const day = Number(match[2]);
    const year = Number(match[3].length === 2 ? `20${match[3]}` : match[3]);
    const parsed = new Date(year, month, day);

    return Number.isNaN(parsed.getTime()) ? null : parsed;
  }

  function relativeDateLabel(date) {
    const now = new Date();
    const diffMs = now.getTime() - date.getTime();
    if (diffMs < 0) return "Updated recently";

    const units = [
      { name: "year", ms: 365 * 24 * 60 * 60 * 1000 },
      { name: "month", ms: 30 * 24 * 60 * 60 * 1000 },
      { name: "week", ms: 7 * 24 * 60 * 60 * 1000 },
      { name: "day", ms: 24 * 60 * 60 * 1000 },
      { name: "hour", ms: 60 * 60 * 1000 },
      { name: "minute", ms: 60 * 1000 },
    ];

    for (const unit of units) {
      const count = Math.floor(diffMs / unit.ms);
      if (count >= 1) return `Updated ${count} ${unit.name}${count === 1 ? "" : "s"} ago`;
    }

    return "Updated just now";
  }

  function updateRelativeDates() {
    $$("[data-support-updated-at]").forEach((dateEl) => {
      const date = parseDateValue(dateEl.dataset.supportUpdatedAt);
      if (!date) return;
      dateEl.textContent = relativeDateLabel(date);
    });
  }

  function updateCategoryCounts() {
    $$(".support-block").forEach((block) => {
      const sectionKey = block.getAttribute("data-id");
      if (!sectionKey) return;

      const section = getSectionById(sectionKey);
      if (!section) return;

      const count = $$(".main-question", section).length;
      const countEl = $(".support-content-subtext", block);
      if (countEl) countEl.textContent = articleCountLabel(count);
    });
  }

  function openAnswer(sectionEl, questionEl) {
    const key = questionEl.getAttribute("data-question");
    if (!key) return;
    const ans = $(`.main-answer[data-answer="${key}"]`, sectionEl);
    if (!ans) return;

    $$(".main-answer", sectionEl).forEach((a) => { hide(a); a.classList.remove("is-open"); });
    $$(".main-question", sectionEl).forEach((q) => { q.classList.remove("is-open"); q.setAttribute("aria-expanded", "false"); });

    show(ans);
    ans.classList.add("is-open");
    questionEl.classList.add("is-open");
    questionEl.setAttribute("aria-expanded", "true");

    const qCol = $(".support-question-block", sectionEl);
    if (qCol) hide(qCol);
    sectionEl.classList.add("answers-only");
    ans.scrollIntoView({ behavior: "smooth", block: "start" });
  }

  // ---------- Breadcrumb ----------
  function ensureCrumb() {
    let bc = $(".support-breadcrumb");
    if (!bc) {
      bc = document.createElement("nav");
      bc.className = "support-breadcrumb";
      bc.setAttribute("aria-label", "Breadcrumb");
      bc.innerHTML = `<ol class="crumbs" role="list"></ol>`;
      const anchor = homeEl || allSections()[0];
      if (anchor && anchor.parentNode) {
        anchor.parentNode.insertBefore(bc, anchor);
      } else {
        document.body.insertBefore(bc, document.body.firstChild);
      }
    }
    return bc;
  }
  function hideBreadcrumb() { const bc = $(".support-breadcrumb"); if (bc) hide(bc); }
  function showBreadcrumb() { const bc = $(".support-breadcrumb"); if (bc) show(bc); }

  function renderBreadcrumb({ sectionKey = null, sectionLabel = null, questionLabel = null }) {
    const bc = ensureCrumb();
    const parts = [];
    showBreadcrumb();
    parts.push(`<li><a href="#" data-bc="home" class="crumb-link">HOME</a></li>`);
    if (sectionKey && sectionLabel) {
      parts.push(`<li><a href="#" data-bc="section" data-id="${encodeURIComponent(sectionKey)}" class="crumb-link">${escapeHtml(sectionLabel)}</a></li>`);
    }
    if (questionLabel) {
      parts.push(`<li aria-current="page">${escapeHtml(questionLabel)}</li>`);
    }
    $(".crumbs", bc).innerHTML = parts.join("");
  }

  // ---------- Hash routing ----------
  // Hash: #sectionKey or #sectionKey/questionKey
  function setHash(sectionKey, questionKey = "") {
    const safeSection = encodeURIComponent(sectionKey || "");
    const safeQuestion = questionKey ? "/" + encodeURIComponent(questionKey) : "";
    const next = "#" + safeSection + safeQuestion;
    if (location.hash !== next) history.replaceState(null, "", next); // no scroll jump
  }
  function parseHash(hashStr = location.hash) {
    const raw = (hashStr || "").replace(/^#/, "");
    if (!raw) return { sectionKey: "", questionKey: "" };
    const [secRaw, qRaw = ""] = raw.split("/");
    return { sectionKey: decodeURIComponent(secRaw || ""), questionKey: decodeURIComponent(qRaw || "") };
  }
  function openFromHash() {
    const { sectionKey, questionKey } = parseHash();
    if (!sectionKey) { showHome(); hideBreadcrumb(); return; }
    const sec = showSection(sectionKey);
    if (!sec) return;
    const secLabel = sectionLabelFrom(sec) || sectionKey.toUpperCase();
    if (questionKey) {
      const qEl = findByData(".main-question", "data-question", questionKey, sec);
      if (qEl) {
        openAnswer(sec, qEl);
        const qLabel = text($("h3", qEl)) || "QUESTION";
        renderBreadcrumb({ sectionKey, sectionLabel: secLabel, questionLabel: qLabel });
        return;
      }
    }
    const qCol = $(".support-question-block", sec);
    if (qCol) show(qCol);
    renderBreadcrumb({ sectionKey, sectionLabel: secLabel });
  }

  function deAlias(id) { for (const k in ID_ALIASES) if (ID_ALIASES[k] === id) return k; return id; }

  // ---------- Click wiring (blocks / questions / crumbs) ----------
  document.addEventListener("click", (e) => {
    const block = e.target.closest(".support-block");
    if (!block) return;
    const sectionKey = block.getAttribute("data-id");
    if (!sectionKey) return;

    const sec = showSection(sectionKey);
    if (!sec) return;

    const label = sectionLabelFrom(block) || sectionKey.toUpperCase();
    renderBreadcrumb({ sectionKey, sectionLabel: label });
    setHash(sectionKey);
  });

  document.addEventListener("click", (e) => {
    const q = e.target.closest(".main-question");
    if (!q) return;
    const sec = q.closest(".support-main-question");
    if (!sec || !sec.classList.contains("is-active")) return;

    openAnswer(sec, q);
    const secLabel = sectionLabelFrom(sec);
    const qLabel = text($("h3", q)) || "QUESTION";
    const secId = deAlias(sec.getAttribute("id"));
    const qKey = q.getAttribute("data-question") || "";

    renderBreadcrumb({ sectionKey: secId, sectionLabel: secLabel, questionLabel: qLabel });
    setHash(secId, qKey);
  });

  document.addEventListener("click", (e) => {
    const a = e.target.closest(".crumb-link");
    if (!a) return;
    const role = a.getAttribute("data-bc");
    if (!role) return;
    e.preventDefault();

    if (role === "home") {
      showHome();
      hideBreadcrumb();
      history.replaceState(null, "", location.pathname + location.search); // clear hash
      return;
    }

    if (role === "section") {
      const sectionKey = decodeURIComponent(a.getAttribute("data-id") || "");
      const sec = showSection(sectionKey);
      if (!sec) return;
      const qCol = $(".support-question-block", sec);
      if (qCol) show(qCol);
      sec.classList.remove("answers-only");
      $$(".main-answer", sec).forEach((a) => { hide(a); a.classList.remove("is-open"); });
      $$(".main-question", sec).forEach((q) => { show(q); q.classList.remove("is-open"); q.setAttribute("aria-expanded", "false"); });
      const secLabel = sectionLabelFrom(sec) || sectionKey.toUpperCase();
      renderBreadcrumb({ sectionKey, sectionLabel: secLabel });
      setHash(sectionKey);
    }
  });

  $$(".main-question").forEach((q) => {
    q.setAttribute("role", "button");
    q.setAttribute("tabindex", "0");
    q.setAttribute("aria-expanded", "false");
  });

  document.addEventListener("keydown", (e) => {
    if ((e.key === "Enter" || e.key === " ") && e.target.classList?.contains("main-question")) {
      e.preventDefault();
      const sec = e.target.closest(".support-main-question");
      if (!sec || !sec.classList.contains("is-active")) return;
      openAnswer(sec, e.target);
      const secLabel = sectionLabelFrom(sec);
      const qLabel = text($("h3", e.target)) || "QUESTION";
      const secId = deAlias(sec.id);
      const qKey = e.target.getAttribute("data-question") || "";
      renderBreadcrumb({ sectionKey: secId, sectionLabel: secLabel, questionLabel: qLabel });
      setHash(secId, qKey);
    }
  });

  window.addEventListener("hashchange", openFromHash);

  // ==============================================================
  //                  SINGLE-INPUT TYPEAHEAD
  // ==============================================================

  // Use your existing hero search input
  const heroInput = (()=>{
    const scoped = $('.hero .search input[type="search"]');
    return scoped || $('input[type="search"]');
  })();
  if (!heroInput) return;

  // Build index from DOM
  const INDEX = [];
  allSections().forEach((sec) => {
    const sectionId = sec.id || "";
    const sectionName = text($(".main-question-title h2", sec)) || sectionId;
    $$(".main-question", sec).forEach((q) => {
      const qKey = q.getAttribute("data-question") || "";
      const qTitle = text($("h3", q));
      const ans   = $(`.main-answer[data-answer="${qKey}"]`, sec);
      const body  = text($(".main-answer-content", ans)) || text(ans);
      INDEX.push({ sectionId, sectionName, qKey, title: qTitle, body });
    });
  });

  function tokenize(q){ return norm(q).split(/[\s,./_-]+/).filter(Boolean); }
  function scoreRow(row, terms, phrase){
    const t = norm(row.title);
    const b = norm(row.body);
    let s = 0;
    if (phrase && t.includes(phrase)) s += 6;
    if (phrase && b.includes(phrase)) s += 2;
    for(const term of terms){
      if(!term) continue;
      if (t.includes(term)) s += 3;
      if (b.includes(term)) s += 1;
      if (t.startsWith(term)) s += 0.5;
    }
    if (t === phrase) s += 4;
    return s;
  }

  function goToArticle(sectionId, qKey){
    const sec = showSection(sectionId);
    if (!sec) return;
    const qEl = findByData(".main-question", "data-question", qKey, sec);
    if (!qEl) return;
    openAnswer(sec, qEl);
    const secLabel = sectionLabelFrom(sec) || sectionId.toUpperCase();
    const qLabel = text($("h3", qEl)) || "QUESTION";
    renderBreadcrumb({ sectionKey: sectionId, sectionLabel: secLabel, questionLabel: qLabel });
    setHash(sectionId, qKey);
    hideDropdown();
  }

  // Dropdown UI (tied to hero input only)
  const sug = document.createElement("div");
  sug.className = "support-suggestions";
  Object.assign(sug.style, {
    position: "absolute",
    left: "0",
    right: "0",
    top: "100%",
    display: "none",
  });

  const wrap = heroInput.closest(".search") || heroInput.parentElement;
  wrap.style.position = "relative";
  wrap.appendChild(sug);

  function hideDropdown(){ sug.style.display = "none"; sug.innerHTML = ""; heroInput.setAttribute("aria-expanded","false"); }
  function showDropdown(){ sug.style.display = ""; heroInput.setAttribute("aria-expanded","true"); }

  function renderSuggestions(items, terms){
    if (!items.length) { hideDropdown(); return; }
    const mark = (str) => {
      let out = str;
      const uniq = Array.from(new Set((terms||[]).filter(Boolean))).sort((a,b)=>b.length-a.length);
      uniq.forEach(w=>{
        const re = new RegExp(`(${w.replace(/[.*+?^${}()|[\]\\]/g,"\\$&")})`,"ig");
        out = out.replace(re, "<mark>$1</mark>");
      });
      return out;
    };
    sug.innerHTML = items.map((it, i) => `
      <button type="button" role="option" class="sug-item" data-sec="${escapeHtml(it.sectionId)}" data-q="${escapeHtml(it.qKey)}"
        ${i===0? 'aria-selected="true"' : ''}>
        <div class="sug-title">${mark(escapeHtml(it.title))}</div>
        <div class="sug-meta">${escapeHtml(it.sectionName)}</div>
      </button>
    `).join("");
    showDropdown();
  }

  const onInput = debounce((val) => {
    const q = (val || "").trim();
    if (!q) { hideDropdown(); return; }
    const phrase = norm(q);
    const terms  = tokenize(q);
    const ranked = INDEX.map(r => ({ r, s: scoreRow(r, terms, phrase) }))
                        .filter(x => x.s > 0)
                        .sort((a,b)=> b.s - a.s)
                        .slice(0, 12)
                        .map(x => x.r);
    renderSuggestions(ranked, terms);
  }, 120);

  heroInput.setAttribute("role","combobox");
  heroInput.setAttribute("aria-autocomplete","list");
  heroInput.setAttribute("aria-expanded","false");

  heroInput.addEventListener("input", (e)=> onInput(e.target.value));
  heroInput.addEventListener("keydown", (e) => {
    const items = $$(".sug-item", sug);
    if (!items.length) return;

    const currentIndex = items.findIndex(el => el.getAttribute("aria-selected")==="true");
    const setActive = (idx) => {
      items.forEach(el => el.removeAttribute("aria-selected"));
      items[idx]?.setAttribute("aria-selected","true");
      items[idx]?.focus();
    };

    if (e.key === "ArrowDown") {
      e.preventDefault();
      setActive(Math.min(items.length-1, currentIndex < 0 ? 0 : currentIndex + 1));
    } else if (e.key === "ArrowUp") {
      e.preventDefault();
      setActive(Math.max(0, currentIndex < 0 ? items.length-1 : currentIndex - 1));
    } else if (e.key === "Enter") {
      e.preventDefault();
      const active = items[currentIndex >= 0 ? currentIndex : 0];
      if (active) goToArticle(active.dataset.sec, active.dataset.q);
    } else if (e.key === "Escape") {
      hideDropdown();
    }
  });

  sug.addEventListener("click", (e) => {
    const btn = e.target.closest(".sug-item");
    if (!btn) return;
    goToArticle(btn.dataset.sec, btn.dataset.q);
  });

  // Close dropdown on outside click / blur
  document.addEventListener("click", (evt) => {
    if (evt.target === heroInput) return;
    if (evt.target.closest(".support-suggestions") === sug) return;
    hideDropdown();
  });
  heroInput.addEventListener("blur", () => {
    setTimeout(() => {
      if (!document.activeElement || !document.activeElement.closest(".support-suggestions")) hideDropdown();
    }, 120);
  });

  // ---------- Init ----------
  if (!location.hash) {
    showHome();
    hideBreadcrumb();
  } else {
    openFromHash();
  }

  updateCategoryCounts();
  updateRelativeDates();
})();

/* Support Page Script - End */
